import api from "@/lib/api";
import { toast } from "sonner";

// Bakiye hatırlatması: güncel cari ekstre için süreli bağlantı üretir ve hazır mesajla WhatsApp'ı açar.
// Pencere tıklama anında açılır (açılır pencere engelleyicisine takılmasın), adres sonra verilir.
export async function sendBalanceReminder(clientId) {
  const w = window.open("", "_blank");
  try {
    const { data } = await api.post(`/clients/${clientId}/statement/share`, {});
    const text = encodeURIComponent(data.message);
    const url = data.phone ? `https://wa.me/${data.phone}?text=${text}` : `https://wa.me/?text=${text}`;
    if (!data.phone) toast.info("Mükellefin geçerli bir telefon numarası kayıtlı değil. WhatsApp'ta kişiyi kendiniz seçin.");
    if (w) w.location.href = url; else window.open(url, "_blank");
  } catch (e) {
    if (w) w.close();
    toast.error(e.response?.data?.detail || "Hatırlatma hazırlanamadı");
  }
}

// Tahsilat makbuzu: süreli bağlantı üretir ve "ödeme için teşekkür" mesajıyla WhatsApp'ı açar.
export async function sendReceiptWhatsApp(txnId) {
  const w = window.open("", "_blank");
  try {
    const { data } = await api.post(`/transactions/${txnId}/receipt/share`, {});
    const text = encodeURIComponent(data.message);
    const url = data.phone ? `https://wa.me/${data.phone}?text=${text}` : `https://wa.me/?text=${text}`;
    if (!data.phone) toast.info("Mükellefin geçerli bir telefon numarası kayıtlı değil. WhatsApp'ta kişiyi kendiniz seçin.");
    if (w) w.location.href = url; else window.open(url, "_blank");
  } catch (e) {
    if (w) w.close();
    toast.error(e.response?.data?.detail || "Makbuz hazırlanamadı");
  }
}

// Makbuzu PDF olarak e-posta ekinde gönderir.
export async function sendReceiptEmail(txnId, email) {
  if (!email) { toast.error("Bu mükellefin kayıtlı e-posta adresi yok. Önce mükellef bilgilerinden ekleyin."); return; }
  if (!window.confirm(`Tahsilat makbuzu ${email} adresine gönderilsin mi?`)) return;
  try {
    await api.post(`/transactions/${txnId}/receipt/email`, {});
    toast.success(`Makbuz ${email} adresine gönderildi`);
  } catch (e) { toast.error(e.response?.data?.detail || "E-posta gönderilemedi"); }
}

// Makbuzu yeni sekmede açar (yazdırma/indirme için).
export async function openReceiptPdf(txnId) {
  const w = window.open("", "_blank");
  try {
    const res = await api.get(`/transactions/${txnId}/receipt/pdf`, { responseType: "blob" });
    const url = window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
    if (w) w.location.href = url; else window.open(url, "_blank");
  } catch (e) {
    if (w) w.close();
    toast.error("Makbuz açılamadı");
  }
}
